export const SET_HAS_DIALOG_OPENED = 'SET_HAS_DIALOG_OPENED';
export const SET_SIDE = 'SET_SIDE';
export const SET_VARIANT = 'SET_VARIANT';
export const SET_CHANGING_SIDES = 'SET_CHANGING_SIDES';
